<template>
  <div class="card">
    <div class="header">
      <div class="left">
        <div class="title">{{ project.name }}</div>
        <div class="subtitle"></div>
      </div>
    </div>
    <div class="content">
      <p>
        <button class="btn" @click="onOpenCurrentProject">
          Open
        </button>
        <button v-if="menuEnabled" class="btn" @click.stop="onClickedMenu('edit')">
          Edit
        </button>
        <button v-if="menuEnabled" class="btn" @click.stop="onClickedMenu('delete')">
          Delete
        </button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    menuEnabled: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  methods: {
    onClickedMenu(commandName) {
      this.$emit('menuClicked', commandName);
    },
    onOpenCurrentProject() {
      this.$emit('openCurrentProject', this.project);
    }
  }
};
</script>

<style lang="less" scoped>
.card {
  margin: 0;
}
.btn:focus {
  outline: none !important;
}
</style>
